module.exports = __webpack_public_path__ + "media/30.6cdc0dc5.mp3";